import {
    alpha,
    OutlinedInputProps, Select,
    styled,
    TextField,
    TextFieldProps,
} from '@mui/material';
import { forwardRef } from "react";
import { SelectProps } from '@mui/material/Select/Select';
import { CustomTextField } from './TextFieldStyled';

export const CustomSelectField = styled(
    ({ variant, ...props }: SelectProps) => (
        <Select {...props} >
            {props.children}
        </Select>
    )
)(({ theme, label }) => ({

    "& .MuiInputLabel-root": {
        color: "#999999 !important",
    },
    "&.MuiFilledInput-root": {
        border: `1px solid ${theme.palette.grey[400]}`,
        overflow: "hidden",
        borderRadius: 4,
        backgroundColor: "transparent",
        transition: theme.transitions.create([
            "border-color",
            "background-color",
            "box-shadow",
        ]),
        "& .MuiInput-input": {
            padding: label ? "21px 12px 4px 12px" : "12px 12px 13px 12px",
        },
        "&:hover": {
            backgroundColor: theme.custom.inputBackground,
            "&::before": {
                border: 0,
            },
        },
        "&.Mui-disabled": {
            backgroundColor: theme.palette.grey[200],
        },
        "&.Mui-focused": {
            backgroundColor: "transparent",
            borderColor: theme.palette.grey[900],
        },
        "&.Mui-error": {
            backgroundColor: "transparent",
            borderColor: theme.palette.error.main,
            "&.Mui-disabled": {
                backgroundColor: theme.palette.grey[200],
            },
        },
        "::before": {
            border: "0 !important",
        },
        "::after": {
            border: 0,
            "&:hover": {
                border: 0,
            },
        },
    },
}));
// TODO: ennek utána nézni
// eslint-disable-next-line react/display-name
const SelectStyled = forwardRef((props: SelectProps, ref) => {
    return (
        <CustomSelectField
            {...props}
            inputRef={ref}
        />
    );
});

export default SelectStyled;
